import {
    Component,
    ViewChild,
    OnDestroy,
    OnInit,
    ChangeDetectionStrategy,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatNavList } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import {
    MatSidenavModule,
    MatSidenav,
    MatSidenavContent,
} from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { SidenavItemComponent } from '../../../../../../shared/components/sidenav/sidenav-item/sidenav-item.component';
import { Subject, takeUntil, tap } from 'rxjs';
import { UserRoleLabelMapping } from '../../../../../../core/enums/users/role';
import { AuthenticatedUser } from '../../../../../../core/models/authenticated-user';
import { SideNavigationIconLink } from '../../../../../../core/models/navigation-icon-link';
import { UserStateService } from '../../../../../user/shared/services/user-state/user-state.service';
import { GoSidenavBottomPanelComponent } from './components/go-sidenav-bottom-panel/go-sidenav-bottom-panel.component';
import { getGoSideNavigationIconLinks } from './constants/go-sidenavigation-links';

@Component({
    selector: 'app-go-navigation',
    imports: [
        FormsModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatSidenavModule,
        MatToolbarModule,
        MatNavList,
        MatRadioModule,
        MatFormFieldModule,
        MatSelectModule,
        MatCheckboxModule,
        MatSidenav,
        MatSidenavContent,
        SidenavItemComponent,
        GoSidenavBottomPanelComponent,
    ],
    templateUrl: './go-navigation.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './go-navigation.component.scss',
})
export class GoNavigationComponent implements OnDestroy, OnInit {
    UserRoleLabelMapping = UserRoleLabelMapping;
    navigationIconLinks!: SideNavigationIconLink[];

    @ViewChild(MatSidenav)
    sidenav!: MatSidenav;

    user: AuthenticatedUser | null = null;

    isCollapsed: boolean = true;

    private readonly destroy$ = new Subject<void>();

    constructor(private readonly userStateService: UserStateService) {}

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngOnInit() {
        this.setupSubscriptions();
        this.navigationIconLinks = getGoSideNavigationIconLinks();
    }

    toggleSidenav() {
        this.sidenav.open();
        this.isCollapsed = !this.isCollapsed;
    }

    private setupSubscriptions() {
        this.userStateService.user$
            .pipe(
                takeUntil(this.destroy$),
                tap((user: AuthenticatedUser | null) => {
                    this.user = user;
                }),
            )
            .subscribe();
    }
}
